var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 87,
    viewBox: "0 0 89 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23608 44.7429C1.23608 33.7602 10.0909 24.8571 21.0139 24.8571H74.1666C81.6761 24.8571 87.7639 30.9781 87.7639 38.5286V68.3571C87.7639 69.73 86.6571 70.8429 85.2916 70.8429H3.70831C2.34293 70.8429 1.23608 69.73 1.23608 68.3571V44.7429Z",
    stroke: "#74808B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23608 44.7429C1.23608 33.7602 10.0909 24.8571 21.0139 24.8571C31.9369 24.8571 40.7916 33.7602 40.7916 44.7429V70.8429H2.13287C1.63759 70.8429 1.23608 70.4392 1.23608 69.9412V44.7429Z",
    stroke: "#74808B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3611 42.2571H27.1944",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.3611 47.2286H21.0139",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7361 70.8429H35.8472V83.2714C35.8472 84.6443 36.954 85.7572 38.3195 85.7572H43.2639C44.6293 85.7572 45.7361 84.6443 45.7361 83.2714V70.8429Z",
    stroke: "#74808B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8611 14.2874H74.1595V1.24286H62.2668C59.2936 1.24286 56.8611 3.68871 56.8611 6.6781V38.5286",
    stroke: "#74808B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8611 44.7428C58.9092 44.7428 60.5694 43.0735 60.5694 41.0143C60.5694 38.955 58.9092 37.2857 56.8611 37.2857C54.813 37.2857 53.1528 38.955 53.1528 41.0143C53.1528 43.0735 54.813 44.7428 56.8611 44.7428Z",
    stroke: "#74808B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/noNotification.459c78f17d3d7a2e5b8b111392d0bd84.svg";
export { ForwardRef as ReactComponent };